/* LUCY & KATE: kleine gedragingen uit het Impulse-thema die Dawn niet heeft.
   1. Stippen onder de productfoto's op mobiel.
   2. Inklapbare voettekstkolommen op mobiel.
   3. Filters dicht bij het laden van de collectie.
   4. Sorteerlijst naast de filterknop op mobiel (Impulse: Filter | Sort).
   5. Terugval voor "Popular picks": laadt de aanbevelingen ook als de
      IntersectionObserver niet afgaat (verborgen tabblad, preview). */
(function () {
  function stippen() {
    var lijst = document.querySelector('.product__media-list');
    if (!lijst || lijst.dataset.lkDots) return;
    var items = lijst.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    lijst.dataset.lkDots = '1';
    var wrap = document.createElement('div');
    wrap.className = 'lk-dots';
    items.forEach(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'lk-dots__dot';
      dot.setAttribute('aria-label', 'Photo ' + (i + 1));
      dot.addEventListener('click', function () {
        lijst.scrollTo({ left: item.offsetLeft - (lijst.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
      });
      wrap.appendChild(dot);
    });
    lijst.parentNode.insertBefore(wrap, lijst.nextSibling);
    function bijwerken() {
      var midden = lijst.scrollLeft + lijst.clientWidth / 2;
      var beste = 0;
      var afstand = Infinity;
      items.forEach(function (item, i) {
        var m = item.offsetLeft + item.offsetWidth / 2;
        var d = Math.abs(m - midden);
        if (d < afstand) {
          afstand = d;
          beste = i;
        }
      });
      wrap.querySelectorAll('.lk-dots__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === beste);
      });
    }
    lijst.addEventListener('scroll', bijwerken, { passive: true });
    bijwerken();
  }

  function voettekst() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('.footer-block, .footer-block__newsletter').forEach(function (blok) {
      if (blok.dataset.lkFold) return;
      var kop = blok.querySelector('.footer-block__heading');
      if (!kop) return;
      blok.dataset.lkFold = '1';
      blok.classList.add('lk-fold');
      kop.setAttribute('role', 'button');
      kop.setAttribute('tabindex', '0');
      kop.setAttribute('aria-expanded', 'false');
      function wissel() {
        var open = blok.classList.toggle('lk-fold--open');
        kop.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      kop.addEventListener('click', wissel);
      kop.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          wissel();
        }
      });
    });
  }

  function filtersDicht() {
    document.querySelectorAll('.facets-vertical details.facets__disclosure-vertical[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  function sorteerMobiel() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var houder = document.querySelector('.facets-vertical .facets-container');
    if (!houder || houder.querySelector('.lk-sort')) return;
    var bron = houder.querySelector('.mobile-facets__sort select');
    if (!bron) return;
    var sel = document.createElement('select');
    sel.className = 'lk-sort';
    sel.setAttribute('aria-label', 'Sort');
    var kop = document.createElement('option');
    kop.value = '';
    kop.textContent = 'Sort';
    sel.appendChild(kop);
    Array.prototype.forEach.call(bron.options, function (o) {
      var n = document.createElement('option');
      n.value = o.value;
      n.textContent = o.textContent.trim();
      sel.appendChild(n);
    });
    var gekozen = new URL(location.href).searchParams.get('sort_by');
    sel.value = gekozen || '';
    sel.addEventListener('change', function () {
      if (!sel.value) return;
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
    var wrap = houder.querySelector('.mobile-facets__wrapper');
    if (wrap && wrap.nextSibling) houder.insertBefore(sel, wrap.nextSibling);
    else houder.appendChild(sel);
  }

  function aanbevelingen() {
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      if (el.dataset.lkRec) return;
      el.dataset.lkRec = '1';
      setTimeout(function () {
        if (el.innerHTML.trim().length || typeof el.loadRecommendations !== 'function') return;
        if (el.observer) el.observer.disconnect();
        el.loadRecommendations(el.dataset.productId);
      }, 2500);
    });
  }

  function start() {
    stippen();
    voettekst();
    filtersDicht();
    sorteerMobiel();
    aanbevelingen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
